/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Diagnosis/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import DiagnosisLetters from './DiagnosisLetters/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Diagnosis({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Unscheduled/DiagnosisAction/Content/Diagnosis"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DiagnosisLetters'}>
<DiagnosisLetters
  viewPath={`${viewPath}/DiagnosisLetters`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}